module.exports = __webpack_public_path__ + "static/media/create-drawing-tutorial.0e3425be.gif";